import { create } from 'zustand';

export type IFilterFields = {
  name: string;
  document: string;
  phone_number: string;
  email: string;
  carrier_id: string;
};

type FiltersState = {
  filtersData: IFilterFields;
  setFiltersData: (filters: IFilterFields) => void;
  clearFilters: () => void;
};

const initalFilters: IFilterFields = {
  name: '',
  document: '',
  phone_number: '',
  email: '',
  carrier_id: '',
};

export const useFilterStore = create<FiltersState>((set) => ({
  filtersData: initalFilters,
  setFiltersData: (filters) => set({ filtersData: filters }),
  clearFilters: () => set({ filtersData: initalFilters }),
}));
